// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonIcon_root__GfNJ6"};